import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { ApplicationState, AppState } from '../../../store';
import { withSnackbar, ProviderContext } from 'notistack';
import { ITranslatorService } from '../../../services/Interfaces/ITranslatorService';
import { ApplicationContext, AppContext } from '../../../context/Contexts';
import {
  Tooltip,
  Box,
  Button,
  IconButton,
  Dialog,
  DialogTitle,
  Grid,
  Typography,
  DialogContent,
  Switch
} from '@material-ui/core';
import { ScaleLoader } from 'react-spinners';
import AddCircleTwoToneIcon from '@material-ui/icons/AddCircleTwoTone';
import { RouteComponentProps } from 'react-router';
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
import Autocomplete from '@material-ui/lab/Autocomplete';
import MUIDataTable, {
  SelectableRows,
  MUIDataTableMeta,
  MUIDataTableColumnOptions
} from 'mui-datatables';
import { MUITranslations } from '../../../helpers/MUITableTranslations';
import CloseIcon from '@material-ui/icons/Close';
import DeleteOutlineTwoToneIcon from '@material-ui/icons/DeleteOutlineTwoTone';
import { ReferentialCode } from '../../../helpers/Constants';
import Referentials from '../../../helpers/Referentials.json';
import { IReferential } from '../../../interfaces/IReferential';
import moment from 'moment';
import { IReferentialService } from '../../../services/Interfaces/IReferentialService';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import { MaintenanceCategoryCountry, MaintenanceCategoryOption } from '../../../interfaces/Case';
import { ICaseService } from '../../../services/Interfaces/ICaseService';
import * as R from 'ramda';
import VisibilityOutlinedIcon from '@material-ui/icons/VisibilityOutlined';

interface IMaintenanceCategoryCountryComponentState {
  newMaintenanceCategoryCountry: MaintenanceCategoryCountry;
  maintenanceCategoryCountries: MaintenanceCategoryCountry[];
  isLoading: boolean;
  isDialogOpen: boolean;
  newMaintenanceCategoryCountryId: number | null;
  countryList: IReferential[];
  maintenanceCategoryList: IReferential[];
  maintenanceOptionList: IReferential[];
  isOptionsDialogOpen: boolean;
  selectedMaintenanceCategoryCountryForOptions: MaintenanceCategoryCountry | null;
}

type IMaintenanceCategoryCountryComponentProps = { appState: AppState } & ProviderContext &
  RouteComponentProps<{ id: string; workflowId: string }>;
class MaintenanceCategoryCountryComponent extends React.PureComponent<
  IMaintenanceCategoryCountryComponentProps,
  IMaintenanceCategoryCountryComponentState
> {
  private translatorService!: ITranslatorService;
  private appReferentialService!: IReferentialService;
  private caseService!: ICaseService;

  static contextType = ApplicationContext;
  private newMaintenanceCategoryCountry: MaintenanceCategoryCountry = {
    id: 0,
    countryId: 0,
    country: null,
    maintenanceCategoryId: 0,
    maintenanceCategory: null,
    isActive: true,
    maintenanceCategoryOptions: [] as MaintenanceCategoryOption[]
  } as MaintenanceCategoryCountry;

  state = {
    isLoading: false,
    isDialogOpen: false,
    newMaintenanceCategoryCountry: this.newMaintenanceCategoryCountry,
    maintenanceCategoryCountries: [],
    newMaintenanceCategoryCountryId: null,
    countryList: [] as IReferential[],
    maintenanceCategoryList: [] as IReferential[],
    maintenanceOptionList: [] as IReferential[],
    isOptionsDialogOpen: false,
    selectedMaintenanceCategoryCountryForOptions: null
  } as IMaintenanceCategoryCountryComponentState;

  public componentDidMount() {
    this.setState(
      {
        isLoading: true
      },
      async () => {
        await this.loadMaintenanceCategoryCountries();
      }
    );
  }

  loadMaintenanceCategoryCountries = async () => {
    const countryRef = Referentials.referential.find(
      (item) => item.code === ReferentialCode.Country
    );
    const maintenanceCategoryRef = Referentials.referential.find(
      (item) => item.code === ReferentialCode.MaintenanceCategory
    );
    const maintenanceOptionRef = Referentials.referential.find(
      (item) => item.code === ReferentialCode.MaintenanceOption
    );

    const [
      maintenanceCategoryCountries,
      countryList,
      maintenanceCategoryList,
      maintenanceOptionList
    ] = await Promise.all([
      this.caseService.MaintenanceCategoryCountryList(),
      this.appReferentialService.Get(countryRef!.baseUrl),
      this.appReferentialService.Get(maintenanceCategoryRef!.baseUrl),
      this.appReferentialService.Get(maintenanceOptionRef!.baseUrl)
    ]);

    maintenanceCategoryCountries.forEach((item) => {
      const maintenanceCategory = maintenanceCategoryList.find(
        (categoryItem) =>
          !R.isNil(item.maintenanceCategoryId) && categoryItem.id === item.maintenanceCategoryId
      );
      const country = countryList.find(
        (countryItem) => !R.isNil(item.countryId) && countryItem.id === item.countryId
      );
      item.country = R.isNil(country) ? null : country;
      item.maintenanceCategory = R.isNil(maintenanceCategory) ? null : maintenanceCategory;
    });

    this.setState({
      maintenanceCategoryCountries: maintenanceCategoryCountries,
      isLoading: false,
      newMaintenanceCategoryCountry: { ...this.newMaintenanceCategoryCountry },
      countryList: countryList,
      maintenanceCategoryList: maintenanceCategoryList,
      maintenanceOptionList: maintenanceOptionList
    });
  };
  buildFullOptionsForSelectedCategory = (
    maintenanceCategoryCountry: MaintenanceCategoryCountry
  ): MaintenanceCategoryOption[] => {
    const maintenanceCategoryId = maintenanceCategoryCountry.maintenanceCategoryId;
    if (!maintenanceCategoryId) return [];

    const filteredOptions = this.state.maintenanceOptionList.filter(
      (o) => o.dependencyId === maintenanceCategoryId
    );

    const existing = maintenanceCategoryCountry.maintenanceCategoryOptions || [];

    return filteredOptions.map((opt) => {
      const existingRow = existing.find((x) => x.maintenanceOptionId === opt.id);

      return {
        id: existingRow?.id || 0,
        maintenanceOptionId: opt.id,
        maintenanceOption: opt,
        maintenanceCategoryCountryId: maintenanceCategoryCountry.id || 0,
        maintenanceCategoryCountry: null,
        isActive: existingRow ? !!existingRow.isActive : false,
        dateCreation: existingRow?.dateCreation || null,
        createdBy: existingRow?.createdBy || null,
        dateModification: existingRow?.dateModification || null,
        modifiedBy: existingRow?.modifiedBy || null
      } as MaintenanceCategoryOption;
    });
  };

  private handleCountryChange = (newValue: IReferential | null) => {
    this.setState({
      newMaintenanceCategoryCountry: {
        ...this.state.newMaintenanceCategoryCountry,
        country: newValue,
        countryId: newValue?.id ?? 0
      }
    });
  };

  private handleMaintenanceCategoryChange = (newValue: IReferential | null) => {
    this.setState((prev) => {
      const nextMcc: MaintenanceCategoryCountry = {
        ...prev.newMaintenanceCategoryCountry,
        maintenanceCategory: newValue,
        maintenanceCategoryId: newValue ? newValue.id : 0
      };

      return {
        newMaintenanceCategoryCountry: {
          ...nextMcc,
          maintenanceCategoryOptions: this.buildFullOptionsForSelectedCategory(nextMcc)
        }
      };
    });
  };

  private getFilteredMaintenanceOptionList = () => {
    const maintenanceCategoryId = this.state.newMaintenanceCategoryCountry.maintenanceCategoryId;
    if (!maintenanceCategoryId) {
      return [] as IReferential[];
    }

    return this.state.maintenanceOptionList.filter(
      (option) => option.dependencyId === maintenanceCategoryId
    );
  };

  private isMaintenanceOptionSelected = (maintenanceOptionId: number) => {
    const row = (this.state.newMaintenanceCategoryCountry.maintenanceCategoryOptions || []).find(
      (o) => o.maintenanceOptionId === maintenanceOptionId
    );
    return !!row?.isActive;
  };

  private handleMaintenanceOptionToggle = (option: IReferential, checked: boolean) => {
    this.setState((prev) => ({
      newMaintenanceCategoryCountry: {
        ...prev.newMaintenanceCategoryCountry,
        maintenanceCategoryOptions: (
          prev.newMaintenanceCategoryCountry.maintenanceCategoryOptions || []
        ).map((o) => (o.maintenanceOptionId === option.id ? { ...o, isActive: checked } : o))
      }
    }));
  };

  public saveMaintenanceCategoryCountry = async () => {
    if (this.state.newMaintenanceCategoryCountryId === null) {
      if (
        this.state.maintenanceCategoryCountries.findIndex(
          (item) =>
            item.countryId === this.state.newMaintenanceCategoryCountry.countryId &&
            item.maintenanceCategoryId ===
              this.state.newMaintenanceCategoryCountry.maintenanceCategoryId
        ) !== -1
      ) {
        this.props.enqueueSnackbar(
          this.translatorService.Tranlate(
            'DUPLICATE_MAINTENANCE_CATEGORY_COUNTRY_ERROR',
            'Exista deja o inregistrare pentru aceasta combinatie de tara si categorie de mentenanta.'
          ),
          { variant: 'error' }
        );
        return;
      }
    } else {
      if (
        this.state.maintenanceCategoryCountries.findIndex(
          (item) =>
            item.id !== this.state.newMaintenanceCategoryCountryId &&
            item.countryId === this.state.newMaintenanceCategoryCountry.countryId &&
            item.maintenanceCategoryId ===
              this.state.newMaintenanceCategoryCountry.maintenanceCategoryId
        ) !== -1
      ) {
        this.props.enqueueSnackbar(
          this.translatorService.Tranlate(
            'DUPLICATE_MAINTENANCE_CATEGORY_COUNTRY_ERROR',
            'Exista deja o inregistrare pentru aceasta combinatie de tara si categorie de mentenanta.'
          ),
          { variant: 'error' }
        );
        return;
      }
    }

    try {
      await this.caseService.AddMaintenanceCategoryCountry(
        this.state.newMaintenanceCategoryCountry
      );
      await this.loadMaintenanceCategoryCountries();
      this.closeDialog();
      this.props.enqueueSnackbar(this.translatorService.Tranlate('SUCCES_MSG', 'OK'), {
        variant: 'success'
      });
    } catch (error) {
      this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
        variant: 'error'
      });
    }
  };

  public renderAddForm() {
    const filteredOptions = this.getFilteredMaintenanceOptionList();
    return (
      <ValidatorForm onSubmit={this.saveMaintenanceCategoryCountry} instantValidate={true}>
        <Box mb={2}>
          <Autocomplete
            id="country"
            fullWidth
            options={this.state.countryList}
            value={this.state.newMaintenanceCategoryCountry.country || ''}
            onChange={(e: any, newValue: IReferential | null) => this.handleCountryChange(newValue)}
            getOptionLabel={(option: IReferential) => option.displayName || ''}
            renderInput={(params) => (
              <TextValidator
                {...params}
                name="country"
                value={this.state.newMaintenanceCategoryCountry.country || ''}
                label={this.translatorService.Tranlate('EDIT_ORGANIZATION_COUNTRY_LABEL', 'Tara')}
                fullWidth
                validators={['required']}
                errorMessages={[
                  this.translatorService.Tranlate('VALIDATORS_REQUIRED', 'Campul este obligatoriu')
                ]}
              />
            )}
          />
        </Box>

        <Box mb={2}>
          <Autocomplete
            id="maintenanceCategory"
            fullWidth
            options={this.state.maintenanceCategoryList}
            value={this.state.newMaintenanceCategoryCountry.maintenanceCategory || ''}
            onChange={(e: any, newValue: IReferential | null) =>
              this.handleMaintenanceCategoryChange(newValue)
            }
            getOptionLabel={(option: IReferential) => option.displayName || ''}
            renderInput={(params) => (
              <TextValidator
                {...params}
                name="maintenanceCategory"
                value={this.state.newMaintenanceCategoryCountry.maintenanceCategory || ''}
                label={this.translatorService.Tranlate(
                  'MAINTENANCE_CATEGORY_LABEL',
                  'Categorie Mentenanta'
                )}
                fullWidth
                validators={['required']}
                errorMessages={[
                  this.translatorService.Tranlate('VALIDATORS_REQUIRED', 'Campul este obligatoriu')
                ]}
              />
            )}
          />
        </Box>

        {filteredOptions.length > 0 ? (
          <Box className="m-2 mt-4">
            <Typography variant="h6" gutterBottom>
              {this.translatorService.Tranlate('MAINTENANCE_OPTIONS_LABEL', 'Optiuni incluse')}
            </Typography>
            <Grid container spacing={1}>
              {filteredOptions.map((option) => (
                <Grid item xs={12} key={option.id}>
                  <Box display="flex" alignItems="center" justifyContent="space-between" py={0.5}>
                    <Box flexGrow={1} pr={2}>
                      <Typography variant="body2">{option.displayName || ''}</Typography>
                    </Box>
                    <Switch
                      checked={this.isMaintenanceOptionSelected(option.id)}
                      onChange={(e) => this.handleMaintenanceOptionToggle(option, e.target.checked)}
                      color="primary"
                      inputProps={{ 'aria-label': 'primary checkbox' }}
                    />
                  </Box>
                </Grid>
              ))}
            </Grid>
          </Box>
        ) : null}

        <div className="text-right">
          <Button className="m-2" variant="outlined" color="default" onClick={this.closeDialog}>
            {this.translatorService.Tranlate('EDIT_ORGANIZATION_CANCEL_BTN', 'Anuleaza')}
          </Button>
          <Button className="m-2" variant="contained" color="secondary" type="submit">
            {this.translatorService.Tranlate('EDIT_ORGANIZATION_SAVE_BTN', 'Salveaza')}
          </Button>
        </div>
      </ValidatorForm>
    );
  }

  handleIsActiveChange = async (
    event: React.ChangeEvent<HTMLInputElement>,
    tableMeta: MUIDataTableMeta
  ) => {
    const id = tableMeta.rowData[0];
    const newMaintenanceCategoryCountries = [...this.state.maintenanceCategoryCountries];
    const updatedMaintenanceCategoryCountryIndex = newMaintenanceCategoryCountries.findIndex(
      (o) => o.id === id
    );

    if (updatedMaintenanceCategoryCountryIndex >= 0) {
      newMaintenanceCategoryCountries[updatedMaintenanceCategoryCountryIndex] = {
        ...newMaintenanceCategoryCountries[updatedMaintenanceCategoryCountryIndex],
        isActive: event.target.checked
      };

      try {
        await this.caseService.UpdateMaintenanceCategoryCountry(
          newMaintenanceCategoryCountries[updatedMaintenanceCategoryCountryIndex]
        );

        this.setState({ maintenanceCategoryCountries: newMaintenanceCategoryCountries });

        this.props.enqueueSnackbar(this.translatorService.Tranlate('SUCCES_MSG', 'OK'), {
          variant: 'success'
        });
      } catch (error) {
        this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
          variant: 'error'
        });
      }
    }
  };

  getColumns = () => {
    const activeLabel = this.translatorService.Tranlate('TABLE_IS_ACTIVE_COLUMN_ACTIVE', 'Activ');
    const inactiveLabel = this.translatorService.Tranlate(
      'TABLE_IS_ACTIVE_COLUMN_INACTIVE',
      'Inactiv'
    );

    const columns = [
      {
        name: 'id',
        label: this.translatorService.Tranlate('COUNTRY_MAINTENANCE_CATEGORY_ID', 'ID'),
        options: {
          filter: false,
          sortDirection: 'desc'
        } as MUIDataTableColumnOptions
      },
      {
        name: 'country',
        label: this.translatorService.Tranlate('ORGANIZATIONS_COUNTRY_HEADER', 'Tara'),
        options: {
          sort: true,
          customSort: (a: IReferential, b: IReferential) => {
            return (a.name ?? '').localeCompare(b.name ?? '');
          },
          customBodyRender: (value: IReferential) => {
            return value ? value.displayName : '';
          }
        } as MUIDataTableColumnOptions
      },
      {
        name: 'maintenanceCategory',
        label: this.translatorService.Tranlate(
          'MAINTENANCE_CATEGORY_LABEL',
          'Categorie Mentenanta'
        ),
        options: {
          sort: true,
          customSort: (a: IReferential, b: IReferential) => {
            return (a.name ?? '').localeCompare(b.name ?? '');
          },
          customBodyRender: (value: IReferential) => {
            return value ? value.displayName : '';
          }
        } as MUIDataTableColumnOptions
      },
      {
        name: 'isActive',
        label: this.translatorService.Tranlate('USERS_IS_ACTIVE_HEADER', 'Activ'),
        options: {
          filterOptions: {
            names: [activeLabel, inactiveLabel],
            logic(isActive: any, filterVal: string[]) {
              const show =
                (filterVal.indexOf(activeLabel) !== -1 && isActive === true) ||
                (filterVal.indexOf(inactiveLabel) !== -1 && isActive === false);
              return !show;
            }
          },
          customBodyRender: (value: boolean, tableMeta: MUIDataTableMeta) => {
            return (
              <Switch
                checked={value}
                onChange={(e) => this.handleIsActiveChange(e, tableMeta)}
                color="primary"
                inputProps={{ 'aria-label': 'primary checkbox' }}
              />
            );
          }
        } as MUIDataTableColumnOptions
      },
      {
        name: 'dateModification',
        label: this.translatorService.Tranlate('USERS_DATE_MODIFICATION_HEADER', 'Data Modificare'),
        options: {
          filter: false,
          sortDirection: 'desc',
          customBodyRender: (value: string | Date | null) =>
            value ? moment.utc(value).local().format(this.props.appState.longDateFormat) : ''
        } as MUIDataTableColumnOptions
      },
      {
        name: '',
        options: {
          viewColumns: false,
          filter: false,
          setCellHeaderProps: () => ({ align: 'center' }),
          setCellProps: () => ({ align: 'center' }),
          customBodyRender: (value: boolean, tableMeta: MUIDataTableMeta) => {
            return (
              <>
                <IconButton
                  aria-label="view"
                  color="primary"
                  size="small"
                  onClick={() => this.openMaintenanceOptionsPopup(tableMeta.rowData[0])}
                >
                  <VisibilityOutlinedIcon />
                </IconButton>
                <IconButton
                  aria-label="edit"
                  color="primary"
                  className="text-primary"
                  size="small"
                  onClick={(e) => this.newMaintenanceCategoryCountryPopup(tableMeta.rowData[0])}
                >
                  <EditOutlinedIcon />
                </IconButton>
                <IconButton
                  aria-label="delete"
                  color="inherit"
                  className="text-danger"
                  size="small"
                  onClick={(e) => this.deleteMaintenanceCategoryCountry(e, tableMeta)}
                >
                  <DeleteOutlineTwoToneIcon />
                </IconButton>
              </>
            );
          }
        }
      }
    ];
    return columns;
  };

  deleteMaintenanceCategoryCountry = async (event: any, tableMeta: MUIDataTableMeta) => {
    try {
      const id = tableMeta.rowData[0];
      await this.caseService.RemoveMaintenanceCategoryCountry(id);
      await this.loadMaintenanceCategoryCountries();
      this.props.enqueueSnackbar(this.translatorService.Tranlate('SUCCES_MSG', 'OK'), {
        variant: 'success'
      });
    } catch (error) {
      this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
        variant: 'error'
      });
    }
  };

  newMaintenanceCategoryCountryPopup = async (maintenanceCategoryCountryId: number | null) => {
    let mcc: MaintenanceCategoryCountry;

    if (maintenanceCategoryCountryId == null) {
      mcc = { ...this.newMaintenanceCategoryCountry } as MaintenanceCategoryCountry;
    } else {
      mcc = this.state.maintenanceCategoryCountries.find(
        (x) => x.id === maintenanceCategoryCountryId
      )!;
    }

    const normalized: MaintenanceCategoryCountry = {
      ...mcc,
      maintenanceCategoryOptions: this.buildFullOptionsForSelectedCategory(mcc)
    };

    this.setState({
      isDialogOpen: true,
      newMaintenanceCategoryCountry: normalized,
      newMaintenanceCategoryCountryId: maintenanceCategoryCountryId
    });
  };

  closeDialog = async () => {
    this.setState({
      isDialogOpen: false,
      newMaintenanceCategoryCountryId: null,
      newMaintenanceCategoryCountry: this.newMaintenanceCategoryCountry
    });
  };

  openMaintenanceOptionsPopup = (maintenanceCategoryCountryId: number) => {
    const mcc = this.state.maintenanceCategoryCountries.find(
      (x) => x.id === maintenanceCategoryCountryId
    );
    if (!mcc) return;

    this.setState({
      isOptionsDialogOpen: true,
      selectedMaintenanceCategoryCountryForOptions: mcc
    });
  };

  closeMaintenanceOptionsPopup = () => {
    this.setState({
      isOptionsDialogOpen: false,
      selectedMaintenanceCategoryCountryForOptions: null
    });
  };

  renderMaintenanceOptionsDialog = () => {
    const { isOptionsDialogOpen, selectedMaintenanceCategoryCountryForOptions } = this.state;

    if (!isOptionsDialogOpen || !selectedMaintenanceCategoryCountryForOptions) {
      return null;
    }

    const options = selectedMaintenanceCategoryCountryForOptions.maintenanceCategoryOptions || [];

    return (
      <Dialog
        onClose={this.closeMaintenanceOptionsPopup}
        open={isOptionsDialogOpen}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>
          <Grid container alignItems="center">
            <Grid item xs={11}>
              <Typography variant="h5">
                {this.translatorService.Tranlate('MAINTENANCE_OPTIONS_LABEL', 'Optiuni incluse')}
              </Typography>
              <Typography variant="body2">
                {selectedMaintenanceCategoryCountryForOptions.country?.displayName || ''} –{' '}
                {selectedMaintenanceCategoryCountryForOptions.maintenanceCategory?.displayName ||
                  ''}
              </Typography>
            </Grid>

            <Grid item xs={1}>
              <IconButton onClick={this.closeMaintenanceOptionsPopup} size="small">
                <CloseIcon />
              </IconButton>
            </Grid>
          </Grid>
        </DialogTitle>

        <DialogContent dividers>
          {options.length > 0 ? (
            <Grid container spacing={1}>
              {options.map((opt) => (
                <Grid item xs={12} key={opt.maintenanceOptionId}>
                  <Box display="flex" alignItems="center" justifyContent="space-between" py={0.5}>
                    <Typography variant="body2">
                      {opt.maintenanceOption?.displayName || ''}
                    </Typography>

                    <Switch checked={!!opt.isActive} color="primary" />
                  </Box>
                </Grid>
              ))}
            </Grid>
          ) : (
            <Typography variant="body2">
              {this.translatorService.Tranlate(
                'NO_MAINTENANCE_OPTIONS',
                'Nu exista optiuni pentru aceasta categorie.'
              )}
            </Typography>
          )}
        </DialogContent>
      </Dialog>
    );
  };

  public render() {
    this.translatorService = (this.context as AppContext).translatorService;
    this.appReferentialService = (this.context as AppContext).referentialService;
    this.caseService = (this.context as AppContext).caseService;

    const options = {
      filter: true,
      selectableRows: 'none' as SelectableRows,
      selectableRowsOnClick: false,
      print: false,
      download: false,
      textLabels: MUITranslations.GetTranslations(this.translatorService),
      sort: false,
      // responsive: "stacked",
      customToolbar: () => {
        return (
          <Tooltip title={this.translatorService.Tranlate('Add', 'Adauga')}>
            <IconButton
              aria-label="add"
              color="secondary"
              className="m-2"
              onClick={(e) => this.newMaintenanceCategoryCountryPopup(null)}
            >
              <AddCircleTwoToneIcon />
            </IconButton>
          </Tooltip>
        );
      }
    };
    return (
      <Fragment>
        <Box mt={1} pt={1}>
          <div className="d-flex flex-row text-center flex-wrap justify-content-center">
            <ScaleLoader color={'var(--primary)'} loading={this.state.isLoading} />
          </div>
          {!this.state.isLoading ? (
            <MUIDataTable
              title={''}
              data={this.state.maintenanceCategoryCountries}
              columns={this.getColumns()}
              options={options}
            />
          ) : null}
        </Box>
        {this.state.isDialogOpen ? (
          <Dialog
            onClose={this.closeDialog}
            aria-labelledby="customized-dialog-title"
            open={this.state.isDialogOpen}
            fullWidth={true}
            maxWidth={'sm'}
          >
            <DialogTitle id="customized-dialog-title">
              <Grid container>
                <Grid item xs={11}>
                  <Typography variant="h4">
                    {!this.state.newMaintenanceCategoryCountryId
                      ? this.translatorService.Tranlate(
                          'MAINTENANCE_CATEGORY_COUNTRY_ADD_MODAL_TITLE',
                          'Adauga categorie de mentenanta pe tara'
                        )
                      : this.translatorService.Tranlate(
                          'MAINTENANCE_CATEGORY_COUNTRY_UPDATE_MODAL_TITLE',
                          'Actualizeaza categorie de mentenanta pe tara'
                        )}
                  </Typography>
                </Grid>
                <Grid item xs={1}>
                  <IconButton aria-label="close" onClick={this.closeDialog} size={'small'}>
                    <CloseIcon />
                  </IconButton>
                </Grid>
              </Grid>
            </DialogTitle>
            <DialogContent dividers>{this.renderAddForm()}</DialogContent>
          </Dialog>
        ) : null}
        {this.renderMaintenanceOptionsDialog()}
      </Fragment>
    );
  }
}
export default connect(
  (state: ApplicationState) => ({
    appState: state.app
  }),
  null
)(withSnackbar(MaintenanceCategoryCountryComponent as any));
